// Visible-viewport bounds for the floating BiQ widget. Uses visualViewport so the
// iOS keyboard / pinch-zoom shrink the usable area; falls back to the window.
import { useEffect, useState } from 'react';

const read = (margin) => {
  const vv = window.visualViewport;
  const ox = vv?.offsetLeft ?? 0;
  const oy = vv?.offsetTop ?? 0;
  const w = vv?.width ?? window.innerWidth;
  const h = vv?.height ?? window.innerHeight;
  return { left: ox + margin, top: oy + margin, right: ox + w - margin, bottom: oy + h - margin, width: w, height: h };
};

export default function useViewportBounds(margin) {
  const [bounds, setBounds] = useState(() => read(margin));

  useEffect(() => {
    let raf = 0;
    const update = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setBounds(read(margin)));
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    window.visualViewport?.addEventListener('resize', update);
    window.visualViewport?.addEventListener('scroll', update);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      window.visualViewport?.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('scroll', update);
    };
  }, [margin]);

  return bounds;
}
